import {
    TEST,
    SET_AUTHORIZATION_STATUS,
    SET_TELEGRAM_STATUS,
    TELEGRAM_AUTHORIZATION_STARTED,
    TELEGRAM_AUTHORIZATION_SUCCESS,
    TELEGRAM_AUTHORIZATION_FAILURE,
    TELEGRAM_WIDGET_AUTHORIZATION_STARTED,
    TELEGRAM_WIDGET_AUTHORIZATION_SUCCESS,
    TELEGRAM_WIDGET_AUTHORIZATION_FAILURE,
    CLASSIC_REGISTRATION_STARTED,
    CLASSIC_REGISTRATION_SUCCESS,
    CLASSIC_REGISTRATION_FAILURE,
    CLASSIC_LOGIN_STARTED,
    CLASSIC_LOGIN_SUCCESS,
    CLASSIC_LOGIN_FAILURE,
    GOOGLE_WIDGET_AUTHORIZATION_STARTED,
    GOOGLE_WIDGET_AUTHORIZATION_SUCCESS,
    GOOGLE_WIDGET_AUTHORIZATION_FAILURE,
    RESET_PASSWORD_STARTED,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    SET_LINK_SCROLL_STATUS
} from "./types";


const initialState = {
    test: false,
    authorizationStatus: !!localStorage.getItem('ftf-token'),
    isTelegram: false,
    telegramAuthorizationStarted: false,
    telegramAuthorization: false,
    telegramAuthorizationErr: false,
    telegramWidgetAuthorizationStarted: false,
    telegramWidgetAuthorization: false,
    telegramWidgetAuthorizationErr: false,
    classicRegistrationStarted: false,
    classicRegistration: false,
    classicRegistrationErr: false,
    classicLoginStarted: false,
    classicLogin: false,
    classicLoginErr: false,
    googleWidgetAuthorizationStarted: false,
    googleWidgetAuthorization: false,
    googleWidgetAuthorizationErr: false,
    resetPasswordStatusStarted: false,
    resetPasswordStatus: false,
    resetPasswordStatusErr: false,
    linkScrollStatus: false
};

export function mainReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_LINK_SCROLL_STATUS:
            return {
                ...state,
                linkScrollStatus: action.payload
            };
        case SET_AUTHORIZATION_STATUS:
            return {
                ...state,
                authorizationStatus: action.payload
            };
        case SET_TELEGRAM_STATUS:
            return {
                ...state,
                isTelegram: action.payload
            };
        case TELEGRAM_AUTHORIZATION_STARTED:
            return {
                ...state,
                telegramAuthorizationStarted: true
            };
        case TELEGRAM_AUTHORIZATION_SUCCESS:
            return {
                ...state,
                telegramAuthorization: action.payload,
                telegramAuthorizationStarted: false
            };
        case TELEGRAM_AUTHORIZATION_FAILURE:
            return {
                ...state,
                telegramAuthorizationErr: action.payload,
                telegramAuthorizationStarted: false
            };
        case TELEGRAM_WIDGET_AUTHORIZATION_STARTED:
            return {
                ...state,
                telegramWidgetAuthorizationStarted: true
            };
        case TELEGRAM_WIDGET_AUTHORIZATION_SUCCESS:
            return {
                ...state,
                telegramWidgetAuthorization: action.payload,
                telegramWidgetAuthorizationStarted: false
            };
        case TELEGRAM_WIDGET_AUTHORIZATION_FAILURE:
            return {
                ...state,
                telegramWidgetAuthorizationErr: action.payload,
                telegramWidgetAuthorizationStarted: false
            };
        case CLASSIC_REGISTRATION_STARTED:
            return {
                ...state,
                classicRegistrationStarted: true
            };
        case CLASSIC_REGISTRATION_SUCCESS:
            return {
                ...state,
                classicRegistration: action.payload,
                classicRegistrationStarted: false
            };
        case CLASSIC_REGISTRATION_FAILURE:
            return {
                ...state,
                classicRegistrationErr: action.payload,
                classicRegistrationStarted: false
            };
        case CLASSIC_LOGIN_STARTED:
            return {
                ...state,
                classicLoginStarted: true
            };
        case CLASSIC_LOGIN_SUCCESS:
            return {
                ...state,
                classicLogin: action.payload,
                classicLoginStarted: false
            };
        case CLASSIC_LOGIN_FAILURE:
            return {
                ...state,
                classicLoginErr: action.payload,
                classicLoginStarted: false
            };
        case GOOGLE_WIDGET_AUTHORIZATION_STARTED:
            return {
                ...state,
                googleWidgetAuthorizationStarted: true
            };
        case GOOGLE_WIDGET_AUTHORIZATION_SUCCESS:
            return {
                ...state,
                googleWidgetAuthorization: action.payload,
                googleWidgetAuthorizationStarted: false
            };
        case GOOGLE_WIDGET_AUTHORIZATION_FAILURE:
            return {
                ...state,
                googleWidgetAuthorizationErr: action.payload,
                googleWidgetAuthorizationStarted: false
            };
        case RESET_PASSWORD_STARTED:
            return {
                ...state,
                resetPasswordStatusStarted: true
            };
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPasswordStatus: action.payload,
                resetPasswordStatusStarted: false
            };
        case RESET_PASSWORD_FAILURE:
            return {
                ...state,
                resetPasswordStatusErr: action.payload,
                resetPasswordStatusStarted: false
            };
        default:
            return state;
    }
}

